module.exports = __webpack_public_path__ + "img/goodsList.2b81bc11.png";